import { lazy, Suspense } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { queryClient } from "@/lib/queryClient";
import { ClientAuthProvider } from "@/auth/ClientAuthProvider";
import { DataProvider } from "@/data/DataProvider";
import type { DataSource } from "@/data/DataSource";
import { Toaster } from "@/components/ui/sonner";
import { router } from "@/routes";

// Demo-only chrome: never downloaded in production.
const DemoBar = lazy(() => import("@/data/demo/DemoBar"));

export default function App({ source }: { source: DataSource }) {
  return (
    <QueryClientProvider client={queryClient}>
      <DataProvider source={source}>
        <ClientAuthProvider>
          <RouterProvider router={router} />
          <Toaster />
          {source.mode === "demo" ? (
            <Suspense fallback={null}>
              <DemoBar />
            </Suspense>
          ) : null}
        </ClientAuthProvider>
      </DataProvider>
    </QueryClientProvider>
  );
}
